import React from 'react';
import { Row, Col, Navbar, FormGroup, FormControl, Alert } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

import SearchEpcListContainer from '../containers/SearchEpcListContainer.jsx';

export default class SearchEpcComponent extends React.Component {

	componentDidMount() {
		this.props.findAllOrderIds();
	}

	componentWillUnmount() {
		this.props.cleanAlert();
	}

	handleSearchEpc(searchEpcInput) {
		this.props.searchEpc(searchEpcInput);
	}

	handleSearchLabelId(searchLabelIdInput) {
		this.props.searchLabelId(searchLabelIdInput);
	}

	handleSearchBagBarcode(searchBagBarcodeInput) {
		this.props.searchBagBarcode(searchBagBarcodeInput);
	}

	handleSearchOrdererName(searchOrdererNameInput, searchOrderIdInput) {
		this.props.searchOrdererName(searchOrdererNameInput, searchOrderIdInput);
	}

	render() {

		let alertDiv = null;
		if (this.props.alertStyle || this.props.alertMessage) {
			alertDiv = (
				<Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
					{this.props.alertMessage}
				</Alert>
			);
		}

		return (
			<div>
				<Row>
					<Col style={{ marginTop: 10 }}>
						{alertDiv}
					</Col>
				</Row>
				<Row>
					<Col>
						<div style={{ textAlign: 'left' }}>
							<Navbar.Form>
								<Row style={{ marginLeft: -15, marginRight: -15 }}>
									<Col xs={12}>
										<FormGroup>
											<FormControl type="text" placeholder='EPC 搜尋' inputRef={ref => { this.searchEpcInput = ref; }} tabIndex="10" size="25"
												onKeyDown={(event) => {
													// keyCode = 13 => eneter 鍵
													if (event.keyCode === 13) {
														this.handleSearchEpc(this.searchEpcInput.value);
													}
												}} />
										</FormGroup>
										<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
											this.handleSearchEpc(this.searchEpcInput.value);
										}} tabIndex="11" />
									</Col>
								</Row>
							</Navbar.Form>
							<Navbar.Form>
								<Row style={{ marginLeft: -15, marginRight: -15 }}>
									<Col xs={12}>
									<div style={{ paddingTop: 5 }}>
										<FormGroup>
											<FormControl type="text" placeholder='洗標條碼 搜尋' inputRef={ref => { this.searchLabelIdInput = ref; }} tabIndex="20" size="25"
												onKeyDown={(event) => {
													// keyCode = 13 => eneter 鍵
													if (event.keyCode === 13) {
														this.handleSearchLabelId(this.searchLabelIdInput.value);
													}
												}} />
										</FormGroup>
										<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
											this.handleSearchLabelId(this.searchLabelIdInput.value);
										}} tabIndex="21" />
									</div>
									</Col>
								</Row>
							</Navbar.Form>
							<Navbar.Form>
								<Row style={{ marginLeft: -15, marginRight: -15 }}>
									<Col xs={12}>
									<div style={{ paddingTop: 5 }}>
										<FormGroup>
											<FormControl type="text" placeholder='標籤條碼 搜尋' inputRef={ref => { this.searchBagBarcodeInput = ref; }} tabIndex="20" size="25"
												onKeyDown={(event) => {
													// keyCode = 13 => eneter 鍵
													if (event.keyCode === 13) {
														this.handleSearchBagBarcode(this.searchBagBarcodeInput.value);
													}
												}} />
										</FormGroup>
										<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
											this.handleSearchBagBarcode(this.searchBagBarcodeInput.value);
										}} tabIndex="21" />
									</div>
									</Col>
								</Row>
							</Navbar.Form>
							<Navbar.Form>
								<Row style={{ marginLeft: -15, marginRight: -15 }}>
									<Col xs={12}>
									<div style={{ paddingTop: 5 }}>
										<FormGroup>
											<FormControl type="text" placeholder='姓名 搜尋' inputRef={ref => { this.searchOrdererNameInput = ref; }} tabIndex="30"
												onKeyDown={(event) => {
													// keyCode = 13 => eneter 鍵
													if (event.keyCode === 13) {
														this.handleSearchOrdererName(this.searchOrdererNameInput.value, this.searchOrderIdInput);
													}
												}} />
										</FormGroup>
										{' '}
										<FormGroup tabIndex="31">
											<Typeahead
												placeholder='請輸入訂單'
												onChange={(event) => {
													if (event[0]) {
														this.searchOrderIdInput = event[0].value;
													} else {
														this.searchOrderIdInput = null;
													}
												}}
												options={this.props.allOrderIds.map((value, key) => ({ label: value, value: value })).toJS()}
											/>
										</FormGroup>
										<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer', paddingTop: 7 }} onClick={(event) => {
											this.handleSearchOrdererName(this.searchOrdererNameInput.value, this.searchOrderIdInput);
										}} tabIndex="32" />
									</div>
									</Col>
								</Row>
							</Navbar.Form>
						</div>
					</Col>
				</Row>
				<Row style={{ paddingTop: 5 }}>
					<Col xs={12}>
						<SearchEpcListContainer />
					</Col>
				</Row>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/SearchEpcComponent.jsx